class LogoCarousel extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector('.logo-carousel__viewport');
    this.track = this.querySelector('.logo-carousel__track');

    const originals = Array.from(this.track.children);
    this.total = originals.length;
    if (this.total === 0) return;

    this.visibleDesktop = Math.min(parseInt(this.dataset.visible) || 4, this.total);
    this.visibleMobile = Math.min(parseInt(this.dataset.visibleMobile) || 2, this.total);
    this.autoPlay = this.dataset.autoPlay !== 'false';
    this.speed = (parseInt(this.dataset.speed) || 4) * 1000;

    // Tripled track: [clones] [originals] [clones] for seamless infinite scroll
    originals.map(el => el.cloneNode(true)).forEach(el => this.track.append(el));
    originals.slice().reverse().map(el => el.cloneNode(true)).forEach(el => this.track.prepend(el));

    this.items = Array.from(this.track.children);
    this.currentIndex = this.total; // start at first original

    // Defer first resize until layout is painted
    requestAnimationFrame(() => {
      this.resize();
      new ResizeObserver(() => this.resize()).observe(this.viewport);
    });

    this.querySelector('.logo-carousel__btn--prev')?.addEventListener('click', () => this.prev());
    this.querySelector('.logo-carousel__btn--next')?.addEventListener('click', () => this.next());

    this.track.addEventListener('transitionend', () => {
      if (this.currentIndex >= 2 * this.total) {
        this.jump(this.currentIndex - this.total);
      } else if (this.currentIndex < this.total) {
        this.jump(this.currentIndex + this.total);
      }
    });

    if (this.autoPlay) {
      this.startAuto();
      this.addEventListener('mouseenter', () => this.stopAuto());
      this.addEventListener('mouseleave', () => this.startAuto());
    }
  }

  get visibleCount() {
    return window.innerWidth <= 749 ? this.visibleMobile : this.visibleDesktop;
  }

  get itemWidth() {
    return this.viewport.getBoundingClientRect().width / this.visibleCount;
  }

  resize() {
    const w = this.itemWidth;
    this.items.forEach(item => { item.style.flex = `0 0 ${w}px`; });
    this.jump(this.currentIndex);
  }

  jump(index) {
    this.currentIndex = index;
    this.track.style.transition = 'none';
    this.track.style.transform = `translateX(${-index * this.itemWidth}px)`;
    this.track.offsetHeight;
    this.track.style.transition = '';
  }

  slide(index) {
    this.currentIndex = index;
    this.track.style.transform = `translateX(${-index * this.itemWidth}px)`;
  }

  next() { this.slide(this.currentIndex + 1); }
  prev() { this.slide(this.currentIndex - 1); }

  startAuto() {
    this.stopAuto();
    this.autoTimer = setInterval(() => this.next(), this.speed);
  }

  stopAuto() { clearInterval(this.autoTimer); }
}

customElements.define('logo-carousel', LogoCarousel);
